if (!customElements.get('banner-image-component')) {
  customElements.define(
    'banner-image-component',
    class BannerImage extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.container = this.closest('[data-section-type]');
        this.handleImageAnimation();

        const title = this.querySelector('[data-banner-title]');

        if (title && !title.classList.contains('text-highlight-wrapper')) {
          const animatedTitle = title.querySelector('[data-aos]');

          if (!animatedTitle) return;

          const textRevealCropper = animatedTitle.closest('.text-reveal__cropper');
          textRevealCropper?.classList.add('overflow-hidden');
          window.theme.waitForAnimationEnd(animatedTitle).then(() => {
            textRevealCropper?.classList.remove('overflow-hidden');
          });
        }
      }

      /**
       * Handles image animation that would be triggered on page load
       *  - uses a fallback class modifier for Banner image section with no cached hero images
       *  - that class resets the default banner CSS animation so it won't be executed when `.img-in` class is added when `img.complete` is detected
       *  - gets the `.lazy-image` container and listens for `transitionend` event of its `<img>` child element
       *  - adds a class modifier after `<img>` transition has completed, when shimmer effect has been removed, that should trigger the hero image animation
       */
      handleImageAnimation() {
        const imageWrapper = this.querySelector('[data-banner-image]');
        const img = imageWrapper.querySelectorAll('.lazy-image');
        const imgComplete = this.container.classList.contains('img-in');

        if (img.length && !imgComplete) {
          this.container.classList.add('banner--no-cached-images');

          const onImageTransitionEnd = (event) => {
            requestAnimationFrame(() => this.container.classList.add('banner--img-loaded'));
            img[0].removeEventListener('transitionend', onImageTransitionEnd);
          };

          img[0].addEventListener('transitionend', onImageTransitionEnd);
        }
      }
    }
  );
}
